import React from 'react';
import Payments from 'api/api-payments';
import { FormBuilder } from '../forms/form';
import { FormattedMessage, injectIntl } from "react-intl";

class TaxIDForm extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorMessage: ''
    };

    this.finalCallback = this.finalCallback.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount () {
    Payments.getRecipientData(PSSessions.Cookies('PSUser'), PSSessions.Cookies('PSAccess'), (res) => {
      if (200 === res.statusCode) {
        this.setState({ recipientObj: res });
      }
    });
  }

  finalCallback (hasError) {
    if (!hasError) {
      this.props.callback();
    }
  }

  submitForm (form, callback) {
    const payload = {
      tax_id: $('#tax-id').val()
    };

    Payments.updateBank(PSSessions.Cookies('PSUser'), PSSessions.Cookies('PSAccess'), payload, (response) => {
      if (200 !== response.statusCode) {
        const errorMessage = response.error ? response.error.message : this.props.intl.formatMessage({ id: 'shared_components.tax_id_form.error_message', defaultMessage: 'An unexpected error occured. Please try again in a few minutes.' });
        this.setState({
          errorMessage
        });
        callback(true);
      } else {
        callback();
      }
    });
  }

  render () {
    let label;
    let placeholder;

    const { recipientObj } = this.state;
    if (!recipientObj) { return <div></div>; }
    const accountDetails = recipientObj.active_account;
    const account = accountDetails.last4;
    const institution = accountDetails.bank_name;
    const subText = `${institution} - ${account}`;
    if ('individual' === recipientObj.type) {
      label = this.props.intl.formatMessage({ id: 'shared_components.tax_id_form.security_number_label', defaultMessage: 'Social Security Number' });
      placeholder = 'XXX-XX-XXXX';
    } else {
      label = this.props.intl.formatMessage({ id: 'shared_components.tax_id_form.identification_number_label', defaultMessage: 'Employer Identification Number (EIN)' });
      placeholder = 'XX-XXXXXXX';
    }

    const formInputs = [
      {
        elementID: 'tax-id',
        inputFieldName: 'tax_id',
        optional: false,
        labelSize: 'col-xs-12',
        helperText: this.props.intl.formatMessage({ id: 'shared_components.tax_id_form.not_store_banking_data', defaultMessage: 'We do not store your banking data. We pass it securely to our payments partner.' }),
        label,
        placeholder
      }
    ];

    return (<div style={{ marginLeft: 45, marginRight: 45 }}>
      <h3 className="heading text-center">
        <FormattedMessage
          id='shared_components.tax_id_form.add_tax_id'
          defaultMessage='Add Your Tax ID'
        />
      </h3>
      <p className="form-standard">
        <FormattedMessage
          id='shared_components.tax_id_form.add_tax_id_description'
          defaultMessage='Please enter your tax ID for your account below. This information is for identity verification required for payouts and tax compliance.'
        />
      </p>
      <div style={{ height: 83 }} className="form-standard bg-gray-100 sborder-gray-400">
        <div className="label text-center" style={{ marginBottom: 7, marginTop: 22 }}>
          <FormattedMessage
            id='shared_components.tax_id_form.payout_account'
            defaultMessage='Your payout account'
          />
        </div>
        <b><p className="text-center">{ subText }</p></b>
      </div>
      <FormBuilder
        formname="taxID"
        id="tax-form"
        formStyle="standard"
        formInputs={formInputs}
        errorText={this.state.errorMessage}
        submitAction={this.submitForm}
        submitCallback={this.finalCallback}
        buttonText={this.props.intl.formatMessage({ id: 'shared_components.tax_id_form.button_update', defaultMessage: 'Update' })}
      />
    </div>);
  }
}

const __e_TaxIDForm = injectIntl(TaxIDForm);

export { __e_TaxIDForm as TaxIDForm };